import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';

import { TableSkeleton } from '@eluve/blocks';
import {
  Button,
  Content,
  Header,
  Heading,
  Icon,
  SidebarTrigger,
  Stack,
} from '@eluve/components';
import { FilterableClinicalTasksTable } from '@eluve/feature-clinical-tasks';
import { useCaptureEventOnMount } from '@eluve/posthog-react';

export const TasksListPage: React.FC = () => {
  useCaptureEventOnMount('page_view_tasks_list');

  return (
    <>
      <Header>
        <SidebarTrigger />
        <Stack
          direction="horizontal"
          align="center"
          justify="between"
          className="my-2 py-2"
        >
          <Heading>Tasks</Heading>
          <Button variant="outline" size="sm" onClick={() => window.print()}>
            <Icon name="Printer" size="sm" />
            Print
          </Button>
        </Stack>
      </Header>
      <Content padded>
        <Suspense fallback={<TableSkeleton rowCount={20} />}>
          <ErrorBoundary
            fallback={
              <Stack gap={2}>
                <p>Failed to load tasks.</p>
                <TableSkeleton rowCount={5} />
              </Stack>
            }
          >
            <FilterableClinicalTasksTable />
          </ErrorBoundary>
        </Suspense>
      </Content>
    </>
  );
};
